<template lang="pug">
modal#qualified-signature-download-plugin-modal(
  :no-footer='true'
  :title='$t("modal.qualifiedSignatureCertificatePluginModal.title")'
  ref='modal'
  size='sm'
)
  p(v-html='$t("modal.qualifiedSignatureCertificatePluginModal.message")') 
  .my-3.text-center
    .text-center.my-4
      img.img-fluid(src='/img/ilustrations/laptop-download.svg')
    template(v-if='osInfo === "windows-64"')
      button.btn.btn-thin(
        @click='downloadPlugin'
        style='border-width: 1px'
        type='button'
      )
        icon(name='windows' type='brands')
        span.text {{ $t('modal.qualifiedSignatureCertificatePluginModal.downloadPlugin') }}
    template(v-if='osInfo === "windows-32"')
      button.btn.btn-thin(
        @click='downloadPlugin'
        style='border-width: 1px'
        type='button'
      )
        icon(name='windows' type='brands')
        span.text {{ $t('modal.qualifiedSignatureCertificatePluginModal.downloadPlugin') }}
    template(v-if='osInfo === "linux"')
      button.btn.btn-thin(
        @click='downloadPlugin'
        style='border-width: 1px'
        type='button'
      )
        icon(name='linux' type='brands')
        span.text {{ $t('modal.qualifiedSignatureCertificatePluginModal.downloadPlugin') }}
    template(v-if='osInfo === "mac"')
      button.btn.btn-thin(
        @click='downloadPlugin'
        style='border-width: 1px'
        type='button'
      )
        icon(name='apple' type='brands')
        span.text {{ $t('modal.qualifiedSignatureCertificatePluginModal.downloadPlugin') }}
    .info-message.text-center.my-4
      icon.info-message__icon(name='triangle-exclamation')
      span.info-message__text {{ $t('modal.qualifiedSignatureCertificatePluginModal.infoMessage') }}
    .text-end.mt-5
      button.btn.btn-primary.ms-4(
        @click='close'
        style='border-width: 1px'
        type='button'
      ) {{ $t('modal.envelope.next') }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'QualifiedSignatureDownloadPluginModal',
  components: {
    Icon,
    Modal,
  },
  data() {
    return {
      osInfo: '',
    };
  },
  created() {
    this.getOsInfo();
  },
  methods: {
    close() {
      this.$refs.modal.close();
      this.$emit('close');
    },
    getOsInfo() {
      if (!window.navigator) {
        return;
      }
      if (
        navigator.userAgent.includes('WOW64') ||
        navigator.userAgent.includes('Win64')
      ) {
        this.osInfo = 'windows-64';
        return;
      }
      if (
        navigator.userAgent.includes('WOW32') ||
        navigator.userAgent.includes('Win32')
      ) {
        this.osInfo = 'windows-32';
        return;
      }
      if (
        navigator.userAgent.includes('WOW32') ||
        navigator.userAgent.includes('Win32')
      ) {
        this.osInfo = 'windows-32';
        return;
      }
      if (navigator.userAgent.includes('Linux')) {
        this.osInfo = 'linux';
        return;
      }
      if (navigator.userAgent.includes('Mac OS')) {
        this.osInfo = 'mac';
        return;
      }
    },
    downloadPlugin() {
      if (this.osInfo === 'linux') {
        window.open(
          'https://s3-sa-east-1.amazonaws.com/repo.birdid.com.br/plugin/latest/Linux/Linux-64/BirdID-Sign-Plugin.AppImage',
          'blank'
        );
      }
      if (this.osInfo === 'mac') {
        window.open(
          'https://s3-sa-east-1.amazonaws.com/repo.birdid.com.br/plugin/latest/MacOS/BirdID-Sign-Plugin.dmg',
          'blank'
        );
      }
      if (this.osInfo === 'windows-32') {
        window.open(
          'https://s3-sa-east-1.amazonaws.com/repo.birdid.com.br/plugin/latest/Windows/Windows-32/birdid-sign-plugin.exe',
          'blank'
        );
      }
      if (this.osInfo === 'windows-64') {
        window.open(
          'https://s3-sa-east-1.amazonaws.com/repo.birdid.com.br/plugin/latest/Windows/Windows-64/birdid-sign-plugin.exe',
          'blank'
        );
      }
    },
  },
};
</script>
<style scoped>
.info-message {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.info-message__text {
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: #666;
}

.info-message__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 12px;
  color: #666;
}

.modal-actions .btn {
  margin-left: auto;
}
</style>
